import type { SidepaneFilterType } from '@app/shared/vue/components/layout/types'

import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCommsFilterStore = defineStore(
  'communicationCardFilter',
  () => {
    const typeFilter = ref<SidepaneFilterType | null>(null)

    function toggleTypeFilter(type: SidepaneFilterType | null): void {
      if (type === typeFilter.value) {
        typeFilter.value = null
      } else {
        typeFilter.value = type
      }
    }

    function clearTypeFilter(): void {
      typeFilter.value = null
    }

    return {
      typeFilter,
      clearTypeFilter,
      toggleTypeFilter,
    }
  }
)
